import * as Yup from 'yup';
import i18n from 'i18next';

export const registerSchema = Yup.object().shape({
  name: Yup.string().trim().required().max(100),
  email: Yup.string()
    .email()
    .required()
    .test('email_format', i18n.t("Only latin characters available"), email => {
      if (email && /[\u0250-\ue007,]+/g.test(email)) {
        return false;
      }
      return true;
    }),
  password: Yup.string().trim().min(8).required(),
  password_confirmation: Yup.string().test('passMatch', 'Passwords must match', function (value) {
    let { password } = this.parent;
    return value === password;
  }),
});
